import {HStack, Text, useStyleConfig} from '@chakra-ui/react';
import type {ResponsiveValue} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';

export const StatutBadge: React.FC<{
  variant: string;
  // Permet une version compacte.
  px?: ResponsiveValue<number | string>;
  py?: ResponsiveValue<number | string>;
  fontSize?: ResponsiveValue<string>;
}> = ({variant, px = 4, py = 1, fontSize = 'xs'}) => {
  const {t} = useTranslation();
  const styles = useStyleConfig('StatutBadge', {variant});

  return (
    <HStack
      sx={styles}
      borderRadius='8px'
      px={px}
      py={py}
      justifyContent='center'
      alignItems='center'
    >
      <Text
        fontSize={fontSize}
        fontWeight='400'
      >
        {t(`commande.${variant}`)}
      </Text>
    </HStack>
  );
};
